import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import Markdown from "react-markdown";


const LLMResponse = ({ text = "", interval = 30 }) => {
  const bufferRef = useRef("");
  const indexRef = useRef(0);
  const [renderedText, setRenderedText] = useState("");
  const [isDone, setIsDone] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      if (indexRef.current >= text.length) {
        clearInterval(timer);
        setIsDone(true);
        return;
      }

      bufferRef.current += text[indexRef.current];
      indexRef.current++;

      if (indexRef.current % 3 === 0 || indexRef.current === text.length)
        setRenderedText(bufferRef.current);
    }, interval);

    return () => clearInterval(timer);
  }, [text, interval]);

  return (
    <div className = "llm-response">
      <Markdown
        components = {{
          p({ node, children }) {
            const isLast = node.position?.end?.offset === renderedText.length;

            return <p className="markdown-line">
                { children }
                { !isDone && isLast && <span className = "cursor" /> }  {/* TODO: fix animatin */}
            </p>;
          },
        }}
      >
        { renderedText }
      </Markdown>
    </div>
  );
};

LLMResponse.propTypes = {
  text: PropTypes.string,
  interval: PropTypes.number,
};

export default LLMResponse;